import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import styles from './LivePlayer.module.scss'
import VimeoEmbed from '@/component/Primitive/VimeoEmbed'
import SelectControl from '@/component/Primitive/SelectControl'
import Container from '@/component/Primitive/Container'
import Stack from '@/component/Primitive/Stack'
import { array, bool } from 'prop-types'

export const LivePlayer = ({ locations, isLive = true, ...other }) => {
  const [vimeoId, setVimeoId] = useState(locations?.[0]?.vimeoId || null)
  const { register, watch } = useForm()
  const currentLocation = watch('location')

  useEffect(() => {
    setVimeoId(currentLocation)
  }, [currentLocation])

  return (
    <div className={styles.LivePlayerWrapper}>
      <Container center gutter size="mediumLarge">
        <Stack>
          {isLive && (
            <div>
              <p className={styles.SelectLabel}>Select a stage</p>
              <SelectControl
                className={styles.SelectControl}
                required
                {...register('location', {
                  onChange: (e) => alert('hello')
                })}
              >
                {locations.map((location) => (
                  <option
                    value={location.vimeoId}
                    key={`State ${location.name}`}
                  >
                    {location.name}
                  </option>
                ))}
              </SelectControl>
            </div>
          )}
          <div className={styles.LivePlayer}>
            <VimeoEmbed videoId={vimeoId} className={styles.VimeoEmbed} />
          </div>
        </Stack>
      </Container>
    </div>
  )
}

LivePlayer.propTypes = {
  isLive: bool,
  locations: array
}
